module.exports = {
  background: [
    {
      from: 1,
      to: 7,
      color: '#aaddff',
    },
    {
      from: 8,
      to: 19,
      color: '#eeeeee',
    },
  ],
  layers: {
    earth: 'earth',
    urban_area: 'urban_area',
    forest: 'forest',
    natural_park: 'natural_park',
    water: 'water',
    country: 'country',
    highway: 'highway',
    interstate_major: 'interstate_major',
    interstate_minor: 'interstate_minor',
    minor_road: 'minor_road',
    minor_road_restricted: 'minor_road_restricted',
    minor_road_oneway: 'minor_road_oneway',
    minor_road_oneway_rev: 'minor_road_oneway_reverse',
    rail: 'rail',
    capital: 'metropolis',
    metropolis: 'metropolis',
    large_city: 'large_city',
    city: 'city',
    settlement: 'settlement',
    other_settlement: 'settlement',
    interstateNumbers: 'interstateNumbers',
    expresswayNumbers: 'highway',
    expresswayintersections: 'interstate_minor',
  },
  renderers: {
    metropolis: [
      {
        from: 17,
        to: 19,
        text: {
          size: 30,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 15,
        to: 16,
        text: {
          size: 24,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 1,
        to: 14,
        text: {
          size: 20,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
    ],
    large_city: [
      {
        from: 17,
        to: 19,
        text: {
          size: 24,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 15,
        to: 16,
        text: {
          size: 18,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 1,
        to: 14,
        text: {
          size: 14,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
    ],
    city: [
      {
        from: 17,
        to: 19,
        text: {
          size: 20,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 15,
        to: 15,
        text: {
          size: 16,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 1,
        to: 14,
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
    ],
    settlement: [
      {
        from: 17,
        to: 19,
        text: {
          size: 18,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 15,
        to: 16,
        text: {
          size: 14,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 1,
        to: 14,
        text: {
          size: 10,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
    ],
    earth: [
      {
        from: 1,
        to: 19,
        polygon: {
          color: '#f2f2f2',
        },
      },
    ],
    urban_area: [
      {
        from: 1,
        to: 19,
        polygon: {
          color: 'rgba(0, 0, 0, 0.05)',
        },
      },
    ],
    forest: [
      {
        from: 1,
        to: 14,
        polygon: {
          color: '#cddfb4',
        },
      },
      {
        from: 15,
        to: 19,
        polygon: {
          color: '#cddfb4',
        },
        text: {
          size: 12,
          color: '#9BA888',
          font: 'Open Sans',
          fontStyle: 'italic',
        },
      },
    ],
    natural_park: [
      {
        from: 1,
        to: 14,
        polygon: {
          color: '#daecbf',
        },
      },
      {
        from: 15,
        to: 19,
        polygon: {
          color: '#daecbf',
        },
        text: {
          size: 12,
          color: '#b3c29d',
          font: 'Open Sans',
          fontStyle: 'italic',
        },
      },
    ],
    water: [
      {
        from: 1,
        to: 19,
        line: {
          color: '#9fd0fc',
          width: 1,
        },
        polygon: {
          color: '#a3cef4',
        },
        text: {
          size: 14,
          color: '#74a8e1',
          font: 'Open Sans',
          fontWeight: 'bold',
          fontStyle: 'italic',
        },
      },
    ],
    country: [
      {
        from: 1,
        to: 19,
        line: {
          color: '#acacac',
        },
        text: {
          size: 18,
          color: '#606060',
          font: 'Open Sans',
          fontWeight: 'bold',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
    ],
    highway: [
      {
        from: 16,
        to: 19,
        line: {
          color: '#f2d078',
          width: 11,
          outlineColor: '#ddac5e',
          outlineWidth: 1,
        },
        image: {
          url: 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJzdmcxMCIgd2lkdGg9IjQwMCIgaGVpZ2h0PSIyNDAiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0MDAgMjQwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgMjQwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6IzIxNkFDNjtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MTA7fTwvc3R5bGU+PHBhdGggaWQ9InBhdGg2IiBjbGFzcz0ic3QwIiBkPSJNMTQsMTk2VjQ0YzAtMi43LDItNC43LDYtNiBsMTc2LTI3LjhjMC0wLjEsMS4zLTAuMiw0LTAuMmMyLjcsMCw0LDAuMSw0LDAuMkwzODAsMzhjNCwxLjMsNiwzLjMsNiw2djE1MmMwLDIuNy0yLDQuNy02LDZsLTE3NiwyNy44YzAsMC4xLTEuMywwLjItNCwwLjIgYy0yLjcsMC00LTAuMS00LTAuMkwyMCwyMDJDMTYsMjAwLjcsMTQsMTk4LjcsMTQsMTk2Ii8+PC9zdmc+',
          width: 33,
          height: 20,
          dx: -16,
          dy: -13,
        },
        text: {
          size: 11,
          color: 'white',
          font: 'Open Sans',
        },
      },
      {
        from: 13,
        to: 15,
        line: {
          color: '#f2d078',
          width: 7,
          outlineColor: '#ddac5e',
          outlineWidth: 1,
        },
        image: {
          url: 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJzdmcxMCIgd2lkdGg9IjQwMCIgaGVpZ2h0PSIyNDAiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0MDAgMjQwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgMjQwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6IzIxNkFDNjtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MTA7fTwvc3R5bGU+PHBhdGggaWQ9InBhdGg2IiBjbGFzcz0ic3QwIiBkPSJNMTQsMTk2VjQ0YzAtMi43LDItNC43LDYtNiBsMTc2LTI3LjhjMC0wLjEsMS4zLTAuMiw0LTAuMmMyLjcsMCw0LDAuMSw0LDAuMkwzODAsMzhjNCwxLjMsNiwzLjMsNiw2djE1MmMwLDIuNy0yLDQuNy02LDZsLTE3NiwyNy44YzAsMC4xLTEuMywwLjItNCwwLjIgYy0yLjcsMC00LTAuMS00LTAuMkwyMCwyMDJDMTYsMjAwLjcsMTQsMTk4LjcsMTQsMTk2Ii8+PC9zdmc+',
          width: 33,
          height: 20,
          dx: -16,
          dy: -13,
        },
        text: {
          size: 11,
          color: 'white',
          font: 'Open Sans',
        },
      },
      {
        from: 10,
        to: 12,
        line: {
          color: '#f2d078',
          width: 4,
          outlineColor: '#ddac5e',
          outlineWidth: 1,
        },
        image: {
          url: 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJzdmcxMCIgd2lkdGg9IjQwMCIgaGVpZ2h0PSIyNDAiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0MDAgMjQwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgMjQwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6IzIxNkFDNjtzdHJva2U6I0ZGRkZGRjtzdHJva2Utd2lkdGg6MTA7fTwvc3R5bGU+PHBhdGggaWQ9InBhdGg2IiBjbGFzcz0ic3QwIiBkPSJNMTQsMTk2VjQ0YzAtMi43LDItNC43LDYtNiBsMTc2LTI3LjhjMC0wLjEsMS4zLTAuMiw0LTAuMmMyLjcsMCw0LDAuMSw0LDAuMkwzODAsMzhjNCwxLjMsNiwzLjMsNiw2djE1MmMwLDIuNy0yLDQuNy02LDZsLTE3NiwyNy44YzAsMC4xLTEuMywwLjItNCwwLjIgYy0yLjcsMC00LTAuMS00LTAuMkwyMCwyMDJDMTYsMjAwLjcsMTQsMTk4LjcsMTQsMTk2Ii8+PC9zdmc+',
          width: 33,
          height: 20,
          dx: -16,
          dy: -13,
        },
        text: {
          size: 11,
          color: 'white',
          font: 'Open Sans',
        },
      },
      {
        from: 6,
        to: 9,
        line: {
          color: '#f2d078',
          width: 2,
        },
      },
    ],
    interstate_major: [
      {
        from: 17,
        to: 19,
        line: {
          width: 10,
          color: '#f9e5a6',
          outlineColor: '#e3d197',
          outlineWidth: 1,
        },
        text: {
          size: 14,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 15,
        to: 16,
        line: {
          width: 7,
          color: '#f9e5a6',
          outlineColor: '#e3d197',
          outlineWidth: 1,
        },
        text: {
          size: 11,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 13,
        to: 14,
        line: {
          width: 4,
          color: '#f9e5a6',
          outlineColor: '#e3d197',
          outlineWidth: 1,
        },
        text: {
          size: 11,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 10,
        to: 12,
        line: {
          width: 1,
          color: '#f9e5a6',
          outlineColor: '#f0dc96',
          outlineWidth: 1,
        },
      },
    ],
    interstate_minor: [
      {
        from: 17,
        to: 19,
        line: {
          width: 10,
          color: '#ffffff',
          outlineColor: '#dddddd',
          outlineWidth: 1,
        },
        text: {
          size: 14,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 15,
        to: 16,
        line: {
          width: 7,
          color: '#ffffff',
          outlineColor: '#dddddd',
          outlineWidth: 1,
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 13,
        to: 14,
        line: {
          width: 4,
          color: '#ffffff',
          outlineColor: '#dddddd',
          outlineWidth: 1,
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: 'white',
          outlineWidth: 2,
        },
      },
      {
        from: 10,
        to: 12,
        line: {
          width: 1,
          color: '#ffffff',
          outlineColor: '#dddddd',
          outlineWidth: 1,
        },
      },
    ],
    minor_road: [
      {
        from: 17,
        to: 19,
        line: {
          width: 7,
          color: '#ffffff',
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: '#ffffff',
          outlineWidth: 2,
        },
      },
      {
        from: 15,
        to: 16,
        line: {
          width: 3,
          color: '#ffffff',
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: '#ffffff',
          outlineWidth: 2,
        },
      },
      {
        from: 13,
        to: 14,
        line: {
          width: 1,
          color: '#ffffff',
        },
      },
    ],
    minor_road_oneway: [
      {
        from: 17,
        to: 19,
        line: {
          color: '#ffffff',
          url: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMCA2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMCA2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojOUI5QTlBO3N0cm9rZS13aWR0aDoxLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9DQo8L3N0eWxlPg0KPGc+DQoJPHBvbHlsaW5lIGNsYXNzPSJzdDAiIHBvaW50cz0iNS45LDUuMSA5LjEsMyA1LjksMC45IAkiLz4NCgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iOS4xIiB5MT0iMyIgeDI9IjAuOSIgeTI9IjMiLz4NCjwvZz4NCjwvc3ZnPg==',
          width: 10,
          height: 6,
          dx: -5,
          dy: -3,
          direction: 'forward',
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: '#ffffff',
          outlineWidth: 2,
        },
      },
      {
        from: 15,
        to: 16,
        line: {
          width: 3,
          color: '#ffffff',
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: '#ffffff',
          outlineWidth: 2,
        },
      },
      {
        from: 13,
        to: 14,
        line: {
          width: 1,
          color: '#ffffff',
        },
      },
    ],
    minor_road_oneway_reverse: [
      {
        from: 17,
        to: 19,
        line: {
          color: '#ffffff',
          url: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMCA2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMCA2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojOUI5QTlBO3N0cm9rZS13aWR0aDoxLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9DQo8L3N0eWxlPg0KPGc+DQoJPHBvbHlsaW5lIGNsYXNzPSJzdDAiIHBvaW50cz0iNS45LDUuMSA5LjEsMyA1LjksMC45IAkiLz4NCgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iOS4xIiB5MT0iMyIgeDI9IjAuOSIgeTI9IjMiLz4NCjwvZz4NCjwvc3ZnPg==',
          width: 10,
          height: 6,
          dx: -5,
          dy: -3,
          direction: 'reverse',
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: '#ffffff',
          outlineWidth: 2,
        },
      },
      {
        from: 15,
        to: 16,
        line: {
          width: 3,
          color: '#ffffff',
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
          outlineColor: '#ffffff',
          outlineWidth: 2,
        },
      },
      {
        from: 13,
        to: 14,
        line: {
          width: 1,
          color: '#ffffff',
        },
      },
    ],
    minor_road_restricted: [
      {
        from: 17,
        to: 19,
        line: {
          width: 7,
          color: '#cccccc',
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
        },
      },
      {
        from: 15,
        to: 16,
        line: {
          width: 1,
          color: '#cccccc',
        },
        text: {
          size: 12,
          color: '#606060',
          font: 'Open Sans',
        },
      },
      {
        from: 13,
        to: 14,
        line: {
          width: 1,
          color: '#cccccc',
        },
      },
    ],
    rail: [
      {
        from: 13,
        to: 19,
        line: {
          width: 1,
          color: '#d4d4d4',
        },
      },
    ],
    interstateNumbers: [
      {
        from: 11,
        to: 19,
        image: {
          url: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkJ1bmRlc3N0cmFzc2UiIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIiB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDIwMCAxMjAiIHdpZHRoPSIyMDAiIGhlaWdodD0iMTIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMDAgMTIwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0Y5REM4MTt9PC9zdHlsZT48cGF0aCBpZD0icmVjdDQiIGNsYXNzPSJzdDAiIGQ9Ik0yMi4zLDBoMTU1LjVDMTkwLDAsMjAwLDEwLDIwMCwyMi4zdjc1LjVjMCwxMi4zLTEwLDIyLjMtMjIuMywyMi4zSDIyLjNDMTAsMTIwLDAsMTEwLDAsOTcuOFYyMi4zIEMwLDEwLDEwLDAsMjIuMywweiIvPjxwYXRoIGlkPSJyZWN0NiIgZD0iTTIyLjMsNC4zaDE1NS41YzkuOSwwLDE4LDguMSwxOCwxOHY3NS41YzAsOS45LTguMSwxOC0xOCwxOEgyMi4zYy05LjksMC0xOC04LjEtMTgtMThWMjIuMyBDNC4zLDEyLjMsMTIuMyw0LjMsMjIuMyw0LjN6Ii8+PHBhdGggaWQ9InJlY3Q4IiBjbGFzcz0ic3QwIiBkPSJNMjIuMywxMS4zaDE1NS41YzYuMSwwLDExLDQuOSwxMSwxMXY3NS41YzAsNi4xLTQuOSwxMS0xMSwxMUgyMi4zYy02LjEsMC0xMS00LjktMTEtMTFWMjIuMyBDMTEuMywxNi4yLDE2LjIsMTEuMywyMi4zLDExLjN6Ii8+PC9zdmc+',
          width: 27,
          height: 17,
          dx: -14,
          dy: -12,
        },
        text: {
          size: 11,
          color: 'black',
          font: 'Open Sans',
        },
      },
    ],
  },
};
